<!-- Card -->
<mat-card style="background: transparent;">
    <div style="height: 20px;"></div>
    <mat-card class="card_style">


        <!-- Head Line -->
        <span class="style">Market Study</span>


        <div class="row top">
            <div class="col-sm-6">

                <table class="table" style="margin-top: 5%;">
                    <tbody>

                        <!-- CRM Listing -->
                        <tr>
                            <td style="width:30%" class="line1"><b class="HeadColor">Market Study</b></td>
                        </tr>

                        <tr>
                            <td style="width:30%" class="line1"><a class="SubColor" (click)="MarketStudy()">Qatar Market
                                    Study</a></td>
                        </tr>
                        <tr>
                            <td style="width:30%" class="line1"><a class="SubColor" (click)="jebelAliMarketStudy()">Jebel-Ali Market Study</a></td>
                        </tr>

                        <tr>
                            <td style="width:30%" class="line1"><a class="SubColor" (click)="Alqousbm()">Alquoz Bm Market Study</a></td>
                        </tr>

                        <tr>
                            <td style="width:30%" class="line1"><a class="SubColor" routerLink="/admin/nepal-market-study">Nepal Wood Market Study</a></td>
                        </tr>

                        <tr>
                            <td style="width:30%" class="line1"><a class="SubColor" routerLink="/admin/nepalautomotive-market-study">Nepal Automotive Market Study</a></td>
                        </tr>




                    </tbody>
                </table>
            </div>



        </div>



    </mat-card>
</mat-card>